<template>
    <el-container>
      <div class="container">
        <div class="searchBox">
          <el-form :inline="true" :model="formData">
            <el-row >
              <el-col :span="8" class="leftAlignTtem">
                  <el-form-item label="零件编码">
                    <el-input v-model="formData.partsCode" placeholder="请输入零件编码 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                  <el-form-item label="零件名称">
                    <el-input v-model="formData.partsName" placeholder="请输入零件名称 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                  <el-form-item label="零件品牌">
                    <el-input v-model="formData.partsBrand" placeholder="请输入零件品牌 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="部品类型">
                  <el-input v-model="formData.partsType" placeholder="请输入部品类型 模糊匹配"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="部品规格">
                  <el-input v-model="formData.partsSpec" placeholder="请输入部品规格 模糊匹配"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="零件分类">
                  <el-input v-model="formData.partsCategoryRaw" placeholder="请输入零件分类 模糊匹配"></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="部件品牌选项">
                  <el-input v-model="formData.brandOption" placeholder="请输入部件品牌选项 模糊匹配"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="电梯品牌">
                  <el-input v-model="formData.zuofanOption" placeholder="请输入电梯品牌 模糊匹配"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="电梯型号">
                  <el-input v-model="formData.zuofanSpec" placeholder="请输入电梯型号 模糊匹配"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" class="leftAlignTtem">
                  <el-form-item label="零件单位名称">
                    <el-input v-model="formData.unit" placeholder="请输入单位名称 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                  <el-form-item label="最小起订量">
                    <el-input v-model="formData.mingroup" placeholder="请输入最小起订量 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="参数描述">
                  <el-input v-model="formData.paramdesc" placeholder="请输入零件型号 模糊匹配"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="未税成本价">
                  <el-input v-model="formData.costNoTaxMin" placeholder="范围搜索" class="shortInput" type="number"></el-input>
                  <span>~</span>
                  <el-input v-model="formData.costNoTaxMax" placeholder="范围搜索" class="shortInput" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="发布价">
                  <el-input v-model="formData.publishPriceMin" placeholder="范围搜索" class="shortInput" type="number"></el-input>
                  <span>~</span>
                  <el-input v-model="formData.publishPriceMax" placeholder="范围搜索" class="shortInput" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="leftAlignTtem">
                <el-form-item label="未税采购价">
                  <el-input v-model="formData.buyCostNoTextMin" placeholder="范围搜索" class="shortInput" type="number"></el-input>
                  <span>~</span>
                  <el-input v-model="formData.buyCostNoTextMax" placeholder="范围搜索" class="shortInput" type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" class="leftAlignTtem">
               <el-form-item label="部品描述和待记事项:">
                  <el-input v-model="formData.partsDesc" placeholder="请输入部品描述和待记事项 模糊匹配" ></el-input>
               </el-form-item>
              </el-col>
              <el-col :span="16" class="leftAlignTtem">
                <el-form-item label="分类:">
                  <el-radio-group v-model="formData.partsCategory" v-removeAriaHidden >
                    <el-radio-button v-for="(item, index) in partsCategoryLabel" :key="index" :label="index" style="margin-left:10px" size="mini">{{ item }}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="gapRow">
              <el-col :span="24" class="">
                <el-form-item>
                  <el-button type="primary" @click="query" icon="el-icon-search"  round >查询</el-button>
                  <el-button round @click="reset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="contentBox" >
        <el-table :data="tableData" max-height="2000"
        v-loading="loading"
        element-loading-text="图片加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left"  class="demo-table-expand expandForm">
              <el-form-item label="部件品牌选项:">
                  <span>{{ props.row.brandOption }}</span>
                </el-form-item>
                <el-form-item label="电梯品牌:">
                  <span>{{ props.row.zuofanOption }}</span>
                </el-form-item>
                <el-form-item label="电梯型号:">
                  <span>{{ props.row.zuofanSpec }}</span>
                </el-form-item>
                <el-form-item label="零件单位名称:">
                  <span>{{ props.row.unit }}</span>
                </el-form-item>
                <el-form-item label="最小起订量:">
                  <span>{{ props.row.mingroup }}</span>
                </el-form-item>
                <el-form-item label="参数描述:">
                  <span>{{ props.row.paramdesc }}</span>
                </el-form-item>
                <el-form-item label="未税成本价:">
                  <span>{{ props.row.costNoTax }}</span>
                </el-form-item>
                <el-form-item label="未税发布价:">
                  <span>{{ props.row.publisPrice }}</span>
                </el-form-item>
                <el-form-item label="未税采购价:">
                  <span>{{ props.row.buyCostNoText }}</span>
                </el-form-item>
                <el-form-item label="部品描述和待记事项:">
                  <span>{{ props.row.partsDesc }}</span>
                </el-form-item>
                <el-form-item label="工时:">
                  <span>{{ props.row.workAmount }}</span>
                </el-form-item>
                <el-form-item label="维修工程码:">
                  <span>{{ props.row.repairCode }}</span>
                </el-form-item>
                <el-form-item label="交期天数:">
                  <span>{{ props.row.deployDays }}</span>
                </el-form-item>
                <el-form-item label="创建时间:">
                  <span>{{ props.row.createTime }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="partsCode" label="部品编号" ></el-table-column>
          <el-table-column prop="partsName" label="部品名称"></el-table-column>
          <el-table-column prop="partsBrand" label="部品品牌" ></el-table-column>
          <el-table-column prop="partsType" label="部品类型" ></el-table-column>
          <el-table-column prop="partsSpec" label="部品规格" ></el-table-column>
          <el-table-column prop="partsCategoryRaw" label="零件分类" ></el-table-column>
          <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button round type="success" size="mini" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑图片</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10,20,30,40,50]"
      :page-size="pageSize"
       layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
      <el-drawer
          title="编辑备件图片"
          :visible.sync="dialog"
          :size="600"
          direction="ltr"
          custom-class="demo-drawer"
          ref="drawer"
          >
          <div class="demo-drawer__content">
            <el-upload
            :action="uploadUrl"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="imageFileList"
            :limit="10"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :data="{partsId:editFormData.id,partsCode:editFormData.partsCode}"
            :headers="headerObj"
            :on-success="handleSuccess"
            :before-remove="beforeRemove"
            >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip" style="margin-top: 10px; margin-bottom: 10px; color:red">只能上传jpg/png文件，且不超过2MB</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          </div>
          <div class="demo-drawer__footer">
              <el-button @click="cancelForm" round size="mini" type="primary">关闭</el-button>
            </div>
        </el-drawer>
      </div>
      </div>
    </el-container>
</template>

<script>
import request from '@/lib/utils'

export default {
  name: 'patrs',
  data () {
    return {
      formData: {
        partsCode: '',
        partsName: '',
        partsBrand: '',
        unit: '',
        mingroup: '',
        paramdesc: '',
        costNoTaxMin: '',
        costNoTaxMax: '',
        publishPriceMin: '',
        publishPriceMax: '',
        buyCostNoTextMin: '',
        buyCostNoTextMax: '',
        partsDesc: '',
        partsCategory: '',
        partsType: '',
        partsSpec: '',
        partsCategoryRaw: '',
        brandOption: '',
        zuofanOption: '',
        zuofanSpec: ''
      },
      partsCategoryLabel: ['通用件', '电气部品', '驱动系统', '电线电缆', '门系统', '控制系统', '消耗物料', '井道系统'],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 1,
      loading: false,
      dialog: false,
      timer: null,
      imageFileList: [],
      uploadUrl: process.env.API_URL + 'parts/uploadPartsImage',
      dialogImageUrl: '',
      dialogVisible: false,
      editFormData: {
        partsId: '',
        partsCode: ''
      },
      headerObj: {
        'auth-token': ''
      }
    }
  },
  mounted () {
    this.query()
    this.headerObj['auth-token'] = localStorage.getItem('auth-token')
  },
  watch: {
    dialog (val) {
      if (val) {
        this.loading = false
        clearTimeout(this.timer)
      } else {
        this.loading = false
      }
    }
  },
  methods: {
    query () {
      const that = this
      let requestData = {
        formClass: 'PartsQuery',
        formData: ''
      }
      let formData = {}
      Object.assign(formData, that.formData)
      formData.pageIndex = that.pageIndex
      formData.pageSize = that.pageSize
      requestData.formData = JSON.stringify(formData)
      console.log(requestData)
      request.post('/parts/queryByPageForm', requestData).then(res => {
        that.tableData = res.obj.list
        that.total = res.obj.total
      }).catch(err => {
        that.$message.error(err)
      })
    },
    reset () {
      this.formData = {
        partsCode: '',
        partsName: '',
        partsBrand: '',
        unit: '',
        mingroup: '',
        paramdesc: '',
        costNoTaxMin: '',
        costNoTaxMax: '',
        publishPriceMin: '',
        publishPriceMax: '',
        buyCostNoTextMin: '',
        buyCostNoTextMax: '',
        partsDesc: '',
        partsCategory: '',
        partsType: '',
        partsSpec: '',
        partsCategoryRaw: '',
        brandOption: '',
        zuofanOption: '',
        zuofanSpec: ''
      }
    },
    handleEdit (row) {
      const that = this
      let imageFileList = []
      request.get('/parts/queryById?id=' + row.id).then(res => {
        that.editFormData = res.obj
        that.editFormData.partsAttachmentList = res.obj.partsAttachmentList
        if (that.editFormData.partsAttachmentList && that.editFormData.partsAttachmentList.length > 0) {
          for (let image of that.editFormData.partsAttachmentList) {
            const file = {
              name: image.docId,
              url: process.env.API_URL.substring(0, process.env.API_URL.length - 1) + image.docUrl,
              id: image.id,
              partsId: image.partsId,
              partsCode: image.partsCode
            }
            imageFileList.push(file)
          }
        }
        that.imageFileList = imageFileList
        that.loading = true
        that.timer = setTimeout(() => {
          that.dialog = true
          that.loading = false
          clearTimeout(that.timer)
        }, 1000)
      }
      ).catch(err => {
        that.$message.error('加载备件图片信息失败' + err)
      })
    },
    handleSizeChange (cureentSize) {
      this.pageSize = cureentSize
      this.query()
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.query()
    },
    handleClose () {
      console.log('drawer close')
      return true
    },
    submitEdit () {
      console.log(this.imageFileList)
    },
    cancelForm () {
      this.loading = false
      this.dialog = false
      clearTimeout(this.timer)
      this.imageFileList = []
    },
    beforeRemove () {
      const remider = this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return true
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
        return Promise.reject(new Error('cancel'))
      })
      return remider
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
      if (file.id) {
        const that = this
        request.post('/parts/deleteAttachById?id=' + file.id).then(res => {
          if (res.code === 'success') {
            that.$message.success('删除成功')
          } else {
            that.$message.error('删除失败' + res.message)
          }
        }).catch(err => {
          that.$message.error('删除失败' + err)
        })
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 2 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG或者PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    handleSuccess (response, _file, fileList) {
      const that = this
      if (response.code !== 'success') {
        that.$message.error('上传图片失败' + response.message)
      }
      that.imageFileList = fileList.filter(item => item.response !== undefined && item.response.code === 'success')
    }

  }
}
</script>

<style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:80% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 80%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

  .shortInput{
    width: 30%;
  }

  .longInput{
    width: 390%;
  }

  .expandForm{
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page/subPage/Parts.vue